module.exports = __webpack_public_path__ + "static/img/ent-detail-95.013afc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-95.jpg
// module id = rS34
// module chunks = 51